import Breaks from "./Breaks";
import CommonFields from "./CommonFields";
import OvertimeRules from "./OvertimeRules";
import { useVisible } from "../../../../../../utils/hooks/useVisible";
import { createNestedObjectWithValues } from "../../../../helpers/historyHelpers/nestedObjectWithValues";
import Schedule from "./Schedule";
import UnionRules from "./UnionRules";
import MealViolationRule from "./MealViolationRule";
import CalculationRules from "./CalculationRules";
import MealAllowanceRule from "./MealAllowanceRule/MealAllowanceRule";
import HolidayRules from "./HolidayRules";
import HistoryTooltipComponent from "../../../../helpers/historyHelpers/components/HistoryTooltipComponent";

function HistoryTooltip({ row }) {
    const { visible, toggle } = useVisible();
    const id = `settings-history-${row.original.id}`;
    let keysLength = (row.original.action !== "create" && row.original.action !== "delete") ? Object.keys(row.original.data).length : 1;
    const formattedData = createNestedObjectWithValues(row.original.data || {});

    return (
        <HistoryTooltipComponent id={id} keysLength={keysLength} visible={visible} toggle={toggle} row={row}>
            <CommonFields type="part-1" data={formattedData} />

            {formattedData?.breaks && <Breaks data={formattedData.breaks} />}

            {formattedData?.overtime && <OvertimeRules data={formattedData.overtime} />}

            {(formattedData?.schedule || formattedData?.scheduleBinding) && (
                <Schedule
                    data={{
                        schedule: formattedData?.schedule,
                        scheduleBinding: formattedData?.scheduleBinding,
                    }}
                />
            )}

            {(formattedData?.clockException || formattedData?.mealPremium || formattedData?.shiftPremium) && (
                <CalculationRules
                    data={{
                        clockException: formattedData?.clockException,
                        mealPremium: formattedData?.mealPremium,
                        shiftPremium: formattedData?.shiftPremium,
                    }}
                />
            )}

            {formattedData?.unionRules && <UnionRules data={formattedData.unionRules} />}

            {formattedData?.mealViolationRule && <MealViolationRule data={formattedData.mealViolationRule} />}

            {formattedData?.mealAllowance && <MealAllowanceRule data={formattedData.mealAllowance} />}

            {formattedData?.holidayRules && <HolidayRules data={formattedData.holidayRules} />}

            <CommonFields type="part-2" data={formattedData} />
        </HistoryTooltipComponent>
    );
}

export default HistoryTooltip;
